module.exports = __webpack_public_path__ + "img/tree_layer_3.cc1c8056.png";